import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  Fade,
  styled,
  keyframes,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Avatar,
} from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import { useFetchBirthdaysQuery } from '../../Home/homeApiSlice';
import { empty } from '../../Gift/assets/index';
import lottie from 'lottie-web';
import nobirthday from '../../../assets/Announcements/nobirthday.json';
import birthday from '../../../assets/Announcements/birthday.json';

const Birthday = () => {
  const { data: birthdays = [], isLoading, isError } = useFetchBirthdaysQuery();
  const animationContainer = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const parseDate = (dateStr) => {
    if (!dateStr) {
      console.error('Invalid date string:', dateStr);
      return new Date(); // or handle it in a way that makes sense for your app
    }
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day); // Note: month is zero-based
  };
  useEffect(() => {
    if (animationContainer.current) {
      const animationData = birthdays.length > 0 ? birthday : nobirthday;
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
      animationContainer.current.style.width = '250px';
      animationContainer.current.style.height = '250px';
    }
    return () => {
      if (animationContainer.current) {
        animationContainer.current.innerHTML = '';
      }
    };
  }, [birthdays]);

  const handleNavigation = (direction) => {
    if (direction === 'next') {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % filteredBirthdays.length);
    } else if (direction === 'prev') {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + filteredBirthdays.length) % filteredBirthdays.length);
    }
  };

  const handleTap = (e) => {
    const screenWidth = e.currentTarget.clientWidth;
    const tapPosition = e.clientX - e.currentTarget.getBoundingClientRect().left;
    const tapDirection = tapPosition < screenWidth / 2 ? 'prev' : 'next';
    handleNavigation(tapDirection);
  };

  const rotate = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

  const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'black',
    color: 'white',
    paddingTop: '20vh',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    position: 'relative',
    borderRadius: 0,
    border: 1,
    borderColor: 'white',
    overflow: 'hidden',
  }));

  const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    '&:nth-of-type(odd)': {
      background: 'linear-gradient(45deg,#102C57,#1679AB)',
    },
    '&:nth-of-type(even)': {
      background: 'linear-gradient(45deg, #1679AB, #102C57)',
    },
  }));

  const StyledTypography = styled(Typography)(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
    // marginTop: '10px',
    color: 'white',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
  }));

  const CounterTypography = styled(Typography)(({ theme }) => ({
    position: 'absolute',
    zIndex: 10,
    color: 'white',
    bottom: 90,
    right: '0',
    left: '40%',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '5px 10px',
    borderRadius: '5px',
  }));

  if (isLoading) {
    return (
      <Box
        sx={{
          backgroundColor: 'black',
          border: 'none',
          borderRadius: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: '100000',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '60vh',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography sx={{ mt: 2, color: 'white' }}>Loading...</Typography>
        </Box>
      </Box>
    );
  }


// const DateArr = birthdays.map((employee) => {
//   const employeeDate = parseDate(employee.dob);
//     return employeeDate.getDate()
// })

// console.log('employeeDate', DateArr)
//   // Filter out anniversaries that are not valid for today
//   const filteredBirthdays = birthdays.filter((employee) => {
//     const today = new Date();
//     const employeeDate = parseDate(employee.dob);
//     if(DateArr.includes(30) && DateArr.includes(1)){
      
//     }
//     return employeeDate.getDate() >= today.getDate();
//   });

// function parseDate1(dob) {
//   const [day, month, year] = dob.split('/').map(Number);
//   return new Date(year, month - 1, day);
// }

// const dateArray = birthdays.map(emp => parseDate(emp.dob).getDate());

// const hasEndOfMonth = dateArray.some(day => day >= 24);
// const hasStartOfMonth = dateArray.some(day => day <= 7);

// let filteredBirthdays;

// if (hasEndOfMonth && hasStartOfMonth) {
//   const endOfMonth = birthdays.filter(emp => {
//     const day = parseDate(emp.dob).getDate();
//     return day >= 24;
//   });

//   const startOfMonth = birthdays.filter(emp => {
//     const day = parseDate(emp.dob).getDate();
//     return day <= 7;
//   });

//   filteredBirthdays = [...endOfMonth, ...startOfMonth];
// } else {
//   filteredBirthdays = birthdays.sort(
//     (a, b) => parseDate(a.dob).getDate() - parseDate(b.dob).getDate()
//   );
// }

const today = new Date();
const todayDay = today.getDate();
const todayMonth = today.getMonth() + 1;
const upcomingBirthdays = birthdays.filter(emp => {
  const [day, month] = emp.EventDate.split('/').map(Number);

  if (month === todayMonth && day >= todayDay) return true;
  if (todayDay >= 24 && (month === todayMonth + 1 || (todayMonth === 12 && month === 1)) && day <= 7) return true;

  return false;
});

const dateArray = upcomingBirthdays.map(emp => parseDate(emp.EventDate).getDate());

const hasEndOfMonth = dateArray.some(day => day >= 24);
const hasStartOfMonth = dateArray.some(day => day <= 7);

let filteredBirthdays;

if (hasEndOfMonth && hasStartOfMonth) {
  const endOfMonth = upcomingBirthdays
    .filter(emp => parseDate(emp.EventDate).getDate() >= 24)
    .sort((a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate());

  const startOfMonth = upcomingBirthdays
    .filter(emp => parseDate(emp.EventDate).getDate() <= 7)
    .sort((a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate());

  filteredBirthdays = [...endOfMonth, ...startOfMonth];
} else {
  filteredBirthdays = upcomingBirthdays.sort(
    (a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate()
  );
}

console.log("filteredBirthdays",filteredBirthdays);

  const formatDate = (dateStr) => {
    const date = parseDate(dateStr);
    const options = { day: 'numeric', month: 'long' };
    return date.toLocaleDateString(undefined, options);
  };

  const isToday = (dateStr) => {
    const date = parseDate(dateStr);
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth();
  };

  if (isError ||  filteredBirthdays?.length === 0) {
    return (
      <Box
        sx={{
          backgroundColor: 'black',
          border: 'none',
          borderRadius: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: '100000',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            marginTop: '10rem',
          }}
        >
          <img style={{ width: '50%' }} src={empty} alt="pending" />
          <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Birthdays This Week</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <StyledCard onClick={handleTap}>
      <CounterTypography>
        {currentIndex + 1}/{filteredBirthdays.length}
      </CounterTypography>
      <Fade in={true} timeout={500} mountOnEnter unmountOnExit>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '45%',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              overflowX: 'scroll',
              scrollBehavior: 'smooth',
              width: '100%',
              height: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              scrollSnapType: 'x mandatory',
              scrollSnapAlign: 'start',
              '& > div': {
                scrollSnapAlign: 'center',
              },
            }}
          >
            {filteredBirthdays.map((employee, index) => (
              <StyledBox
                key={employee._id || index}
                sx={{
                  flex: '0 0 auto',
                  width: isSmallScreen ? '100%' : '100%',
                  height: '100%',

                  transform: `translateX(-${currentIndex * 100}%)`,
                  transition: 'transform 0.5s ease',
                }}
              >
                {/* <StyledTypography>
               Happy Birthday
                </StyledTypography> */}
                <Avatar
                  src={employee.UserImage}
                  sx={{
                    mt: 1.5,
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    border: '4px solid white',
                     img: { objectFit: 'cover', objectPosition: 'top' }
                  }}
                />
                {/* <UserAvatar
                  src={employee.employeePhotoPath}
                  sx={{
                    mt: 1.5,
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    border: '4px solid white',
                  }}
                /> */}
                <Typography sx={{ color: 'white', marginTop: '5px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                  Happy Birthday
                </Typography>

                <StyledTypography>
                  {employee.FirstName} {employee.LastName}
                </StyledTypography>
                <Typography
                  variant="body2"
                  sx={{ color: 'white', marginTop: '5px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
                >
                  {isToday(employee?.EventDate) ? 'Today' : formatDate(employee?.EventDate)} 🎉
                </Typography>
              </StyledBox>
            ))}
          </Box>
        </Box>
      </Fade>
    </StyledCard>
  );
};

export default Birthday;
